import TableHeadCell from './TableHeadCell';

export default TableHeadCell;
